import API from '../Utils/API';

export const getCustomers = (params, successCallback) => (dispatch) => {
  dispatch({ type: 'GET_CUSTOMERS_REQUEST' });
  API.get(`api/organization_customers${params}`, successCallback)
    .then((response) => {
      dispatch({ type: 'GET_CUSTOMERS_SUCCESS', payload: response.data });
      successCallback(response?.data);
    })
    .catch((error) => {
      try {
        dispatch({
          type: 'GET_CUSTOMERS_FAILURE',
          payload: error.response.data,
        });
      } catch {}
    });
};

export const getCustomerById = (Id) => (dispatch) => {
  dispatch({ type: 'GET_CUSTOMER_BY_ID_REQUEST' });
  API.get(`api/organization_customer/${Id}`)
    .then((response) => {
      dispatch({
        type: 'GET_CUSTOMER_BY_ID_SUCCESS',
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_CUSTOMER_BY_ID_FAILURE',
        payload: error?.response.data,
      });
    });
};

export const getCustomerOrders = (params) => (dispatch) => {
  dispatch({ type: 'GET_CUSTOMER_ORDERS_REQUEST' });
  API.get(`api/customer_orders${params}`)
    .then((response) => {
      dispatch({
        type: 'GET_CUSTOMER_ORDERS_SUCCESS',
        payload: response?.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_CUSTOMER_ORDERS_FAILURE',
        payload: error?.response?.data,
      });
    });
};
export const getCustomerSurveys = (params) => (dispatch) => {
  dispatch({ type: 'GET_CUSTOMER_SURVEYS_REQUEST' });
  API.get(`api/customer_surveys${params}`)
    .then((response) => {
      dispatch({
        type: 'GET_CUSTOMER_SURVEYS_SUCCESS',
        payload: response?.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_CUSTOMER_SURVEYS_FAILURE',
        payload: error?.response?.data,
      });
    });
};

export const getCustomerQueueActivity = (params) => (dispatch) => {
  dispatch({ type: 'GET_CUSTOMER_QUEUE_ACTIVITY_REQUEST' });
  API.get(`api/customer_queue${params}`)
    .then((response) => {
      dispatch({
        type: 'GET_CUSTOMER_QUEUE_ACTIVITY_SUCCESS',
        payload: response?.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_CUSTOMER_QUEUE_ACTIVITY_FAILURE',
        payload: error?.response?.data,
      });
    });
};
